<template>
  <div class="cgll-warp">
    <div class="left">
      <div class="btn-content dn-content-bg">
        <el-button type="primary" @click="bindShowAddRentalArea('add')">新增 </el-button>
        <el-button type="primary" @click="bindShowAddRentalArea('edit')">编辑</el-button>
        <el-button type="primary" @click="delRentalArea">删除</el-button>
        <el-button type="primary" @click="jlsz()">计量设置</el-button>
        <el-button type="primary" @click="jljjsz()">计量计价设置</el-button>
        <el-button type="primary" @click="bindShowFtjjszVisible">分摊计价设置</el-button>
      </div>
      <div class="left-table dn-content-bg table-warp">
        <el-table border ref="tableDataRen" row-key="id" :data="tableDataRen" height="100%" highlight-current-row @row-click="handleRowClickAental" style="width: 100%">
          <template v-for="(item, index) in columnsLeft">
            <el-table-column v-if="item.show != false" :key="index" :prop="item.prop" :label="item.label" :align="item.align?'center':'left'"></el-table-column>
          </template>
        </el-table>
      </div>
    </div>
    <div class="right">
      <div class="btn-content dn-content-bg">
        <el-button type="primary" @click="bindShowAddRentalAreaParam('add')">新增</el-button>
        <el-button type="primary" @click="bindShowAddRentalAreaParam('edit')">修改</el-button>
        <el-button type="primary" @click="delRentalAreaParam">删除</el-button>
      </div>
      <div class="right-table dn-content-bg table-warp">
        <el-table border height="100%" ref="rentalAreaData" :data="rentalAreaData" highlight-current-row @current-change="handleRowClickAentalParam" style="width: 100%">
          <template v-for="(item, index) in columnsRight">
            <el-table-column v-if="item.show != false" :key="index" :prop="item.prop" :label="item.label" :align="item.align?item.align:'center'"></el-table-column>
          </template>
        </el-table>
      </div>
    </div>
    <el-dialog :title="addRentalAreaGroupTitle" :visible.sync="addRentalAreaGroupVisible" width="500px">
      <el-form label-width="80px">
        <el-form-item label="名称">
          <el-input v-model="rentalAreaGroupFrom.name"></el-input>
        </el-form-item>
        <el-form-item label="排序编号" class="order">
          <el-input-number v-model="rentalAreaGroupFrom.orderNum" :min="1"></el-input-number>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="addRentalAreaGroup">确定</el-button>
          <el-button style="margin-right:15px" @click="addRentalAreaGroupVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 场地新增编辑弹窗开始 -->
    <el-dialog :title="addRentalAreaTitle" :visible.sync="addRentalAreaVisible" width="500px" :close-on-click-modal="false" @close="formCloserental">
      <el-form label-width="100px" :model="rentalAreaFrom" ref="rentalAreaFrom" :rules="rules">
        <el-form-item label="名称" prop="name" :inline-message="true" class="nc">
          <el-input v-model="rentalAreaFrom.name"></el-input>
        </el-form-item>
        <el-form-item label="显示名称" prop="displayName" :inline-message="true" class="nc">
          <el-input v-model="rentalAreaFrom.displayName"></el-input>
        </el-form-item>
        <el-form-item label="位置" prop="place" :inline-message="true" class="nc">
          <el-input v-model="rentalAreaFrom.place"></el-input>
        </el-form-item>
        <el-form-item label="排序编号">
          <el-input-number v-model="rentalAreaFrom.orderNum" :min="1"></el-input-number>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="addRentalArea">确定</el-button>
          <el-button style="margin-right:15px" @click="addRentalAreaVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 场地新增编辑弹窗结束 -->
    <!-- 场地参数新增编辑弹窗开始 -->
    <el-dialog :title="addRentalAreaParamTitle" :visible.sync="addRentalAreaParamVisible" width="500px" :close-on-click-modal="false" @close="formCloserentalParam">
      <el-form label-width="100px" :model="rentalAreaFromParam" ref="rentalAreaFromParam" :rules="rules">
        <el-form-item label="名称" prop="name" :inline-message="true" class="nc">
          <el-input v-model="rentalAreaFromParam.name" :disabled="noDis"></el-input>
        </el-form-item>
        <el-form-item label="显示名称" prop="displayName" :inline-message="true" class="nc">
          <el-input v-model="rentalAreaFromParam.displayName"></el-input>
        </el-form-item>
        <el-form-item label="参数" :inline-message="true" class="nc">
          <el-input v-model="rentalAreaFromParam.value"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="addRentalAreaParam">确定</el-button>
          <el-button style="margin-right:15px" @click="addRentalAreaParamVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 场地参数新增编辑弹窗结束 -->
    <!-- 计量设置弹窗 -->
    <el-dialog title="计量设置" class="jlSet" :visible.sync="companyJL" width="60%" :close-on-click-modal="false" @close="formCloseJL">
      <el-form :inline="true" class="jlForm">
        <el-button type="primary" size="small" @click="add()">新增</el-button>
        <el-button type="success" size="small" @click="update()">编辑</el-button>
        <el-button type="danger" size="small" @click="del()">删除</el-button>
      </el-form>
      <div class="jlTable table-warp">
        <el-table max-height="400px" :data="jlData" ref="jlData" style="width: 100%" header-align="center" border highlight-current-row @current-change="handleCurrentChangeJL">
          <el-table-column prop="id" label="id" align="center"></el-table-column>
          <el-table-column prop="startTime" label="开始时间" align="center"></el-table-column>
          <el-table-column prop="endTime" label="结束时间" align="center"></el-table-column>
          <el-table-column prop="measureId" label="测量点id" align="center"></el-table-column>
          <el-table-column prop="measureName" label="测量点名称" align="center"></el-table-column>
          <el-table-column prop="pointCode" label="测量点编码" :formatter="metertypechangeC" align="center"></el-table-column>
          <el-table-column prop="pointNumber" label="测量编号" align="center"></el-table-column>
          <el-table-column prop="energyType" label="能源类型" align="center" :formatter="metertypechangeE"></el-table-column>
        </el-table>
      </div>

      <el-pagination style="text-align: right;
          margin-top: 1rem;" background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page.pageIndex?page.pageIndex:0" :page-sizes="page.pageSizes" :page-size="page.pageSizes[0]" layout="total,  prev, pager, next,sizes" :total="page.total"></el-pagination>
    </el-dialog>
    <!-- 计量点设置新增弹窗 -->
    <el-dialog title="新增" :visible.sync="company" width="600px" :close-on-click-modal="false" @close="formCloseJLAdd">
      <el-form label-width="120px" :model="formJL" ref="addForm" :rules="rules" class="demo-form-inline">
        <!-- :inline="true" -->
        <input type="password" style="display:none" />
        <el-row>
          <el-form-item label="场地id:" style="margin-bottom:10px" prop="rentalAreaId" :inline-message="true" class="nc">
            <el-input v-model="formJL.rentalAreaId" placeholder="请输入" autocomplete="off" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="时间:">
            <el-date-picker v-model="search.dates" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :unlink-panels="true" align="right"></el-date-picker>
          </el-form-item>
          <el-form-item label="测量点名称:" style="margin-bottom:10px" :inline-message="true" class="nc">
            <el-input v-model="formJL.measureName" placeholder="请选择" autocomplete="off" :disabled="true" style="width:198px"></el-input>
            <el-button @click="selectACl()">请选择</el-button>
          </el-form-item>
          <el-form-item label="测量点编码:" style="margin-bottom:10px" prop="pointCode" :inline-message="true" class="nc">
            <el-select v-model="formJL.pointCode" placeholder="请选择" class="select" clearable style="width:197px">
              <el-option v-for="(items,index) in bmData" :key="index" :label="items.name" :value="items.pointCode"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="计量能源类型:" prop="energyType" style="margin-bottom:10px" :inline-message="true" class="nc">
            <el-select v-model="formJL.energyType" placeholder="请选择" class="select" clearable style="width:197px">
              <el-option v-for="(items,index) in endata" :key="index" :label="items.name" :value="items.id"></el-option>
            </el-select>
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" style="margin-right:210px">
        <el-button type="primary" @click="SaveJL" class="btn">保 存</el-button>
        <el-button @click="qxJLAdd('addform')" class="cancel">取 消</el-button>
      </div>
    </el-dialog>
    <!--计量设置编辑弹窗  -->
    <el-dialog title="编辑" :visible.sync="company1" width="45%" :close-on-click-modal="false" @close="formCloseJLUpdate">
      <el-form label-width="120px" :model="upformJL" ref="updateForm" :rules="rules" :inline="true" class="demo-form-inline">
        <input type="password" style="display:none" />
        <el-row>
          <el-form-item label="计量点id:" style="margin-bottom:10px" prop="measuringId" :inline-message="true" class="nc">
            <el-input v-model="upformJL.measuringId" placeholder="请输入" autocomplete="off" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="时间:">
            <el-date-picker v-model="search1.dates" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :unlink-panels="true" align="right"></el-date-picker>
          </el-form-item>
          <el-form-item label="测量点名称:" style="margin-bottom:10px" :inline-message="true" class="nc">
            <el-input v-model="upformJL.measureName" placeholder="请选择" autocomplete="off" :disabled="true" style="width:198px"></el-input>
            <el-button @click="selectBCl()">请选择</el-button>
          </el-form-item>
          <el-form-item label="测量点编码:" style="margin-bottom:10px" prop="pointCode" :inline-message="true" class="nc">
            <el-select v-model="upformJL.pointCode" placeholder="请选择" class="select" clearable style="width:197px">
              <el-option v-for="(items,index) in bmData" :key="index" :label="items.name" :value="items.pointCode"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="计量能源类型:" prop="energyType" style="margin-bottom:10px" :inline-message="true" class="nc">
            <el-select v-model="upformJL.energyType" placeholder="请选择" class="select" clearable style="width:197px">
              <el-option v-for="(items,index) in endata" :key="index" :label="items.name" :value="items.id"></el-option>
            </el-select>
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer" style="margin-right:210px">
        <el-button type="primary" @click="upSaveJL" class="btn">保 存</el-button>
        <el-button @click="qxJLUp('updateForm')" class="cancel">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 计量设置树弹窗 -->
    <el-dialog :title="treetitle" :visible.sync="treealarm" width="60%" height="50%" :close-on-click-modal="false" @close="formClosetree">
      <div class="treewindow">
        <div class="body_item">
          <div class="left_tree">
            <el-tree default-expand-all highlight-current :data="windowtreedata" height="100%" :props="treeprop" @node-click="handleNodeClickJL"></el-tree>
          </div>
          <div class="right_table">
            <nk-table :showPage="false" :page="page" height="100%" :data="treerightData" :columns="treerightcolumns" :rowselect="rowselect" @rowselectChange="treerightselectChange"></nk-table>
            <!-- @rowselectChange="treerightselectChange" -->
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="treesave" class="btn">确 定</el-button>
        <el-button @click="qxTree()" class="cancel">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 计量设置结束 -->
    <!-- 计量计价设置开始 -->
    <el-dialog title="计量计价设置" :visible.sync="companyJJ" width="1300px" :close-on-click-modal="false" @close="formCloseJL">
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="电" name="1">
          <div class="itemsLeft" style="height:500px">
            <div class="itemgrounp table-warp">
              <div class="btnbox_">
                <el-button type="primary" size="small" v-popover:tlAddPop @click="eleclick('add')">新增</el-button>
                <el-button type="success" size="small" @click="eleclick('edit')">编辑</el-button>
                <el-button type="info" size="small" @click="eleDeleteClick">删除</el-button>
              </div>
              <el-table border ref="singleTable1" :data="leftTableEle" highlight-current-row height="400" @row-click="rowselectChange" style="width:90%;margin-top:5px;height:400px;overflow: auto">
                <template v-for="(item, index) in left_columns">
                  <el-table-column v-if="item.show != false" :key="index" :prop="item.prop" :label="item.label" :align="item.align?item.align:'center'" :formatter="item.formatter?item.formatter :null"></el-table-column>
                </template>
              </el-table>
            </div>
            <div class="itemgrounp">
              <div calss="elefeng" v-if="form.region=='1'">
                <div class="eletable table-warp">
                  <p>单价</p>
                  <el-table :data="tableData2" border :fit="true" style="width: 100%" height="20%" highlight-current-row size="small">
                    <el-table-column v-for="(item,index) in eleTopcolumns" :key="index" :label="item.label" align="center">
                      <template slot-scope="scope">
                        <el-input v-model="scope.row['type'+index]"></el-input>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <div class="eletable table-warp">
                  <p>时段</p>
                  <el-table :data="tableDataF" border :fit="true" style="width:100%" height="270px" highlight-current-row size="small">
                    <el-table-column v-for="(item,index) in eleBotcolumns" :key="index" :label="item.label" align="center" width="170px">
                      <template slot-scope="scope">
                        <el-time-picker class="timeset" style="width:140px" v-if="index==0" v-model="scope.row['time'+index]" :picker-options="scope.row['time'+(index+1)]" format="HH:mm" value-format="HH:mm" placeholder="选择时间"></el-time-picker>
                        <el-time-picker class="timeset" style="width:140px" v-if="index==1" format="HH:mm" value-format="HH:mm" v-model="scope.row['time'+index]" :picker-options="scope.row['time'+(index-1)]" placeholder="选择时间"></el-time-picker>
                        <el-select v-if="index==2" v-model="scope.row['time'+index]" placeholder="请选择活动区域">
                          <el-option label="峰" value="1"></el-option>
                          <el-option label="平" value="2"></el-option>
                          <el-option label="谷" value="3"></el-option>
                          <el-option label="尖" value="4"></el-option>
                        </el-select>
                      </template>
                    </el-table-column>
                    <el-table-column label="操作" align="center">
                      <template slot-scope="{row,$index}">
                        <span class="addrow" @click="addrowtime">增加一行</span>
                        <span class="addrow" @click="delerowtime($index)">删除</span>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
              <div calss="elebuy" v-if="form.region=='2'">
                <el-form ref="form" :model="elebuyform" label-width="80px">
                  <el-form-item label="单价">
                    <el-input style="width:218px;" v-model="elebuyform.price"></el-input>
                  </el-form-item>
                </el-form>
              </div>
              <!-- 商业 -->

              <!-- 阶梯 -->
              <div calss="jieti table-warp" v-if="form.region=='3'">
                <el-table :data="tableData3" border :fit="true" style="width: 100%" height="400px" highlight-current-row size="small">
                  <el-table-column label="阀值" align="center">
                    <template slot-scope="scope">
                      <el-input v-model="scope.row['jiti0']"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column label="单价" align="center">
                    <template slot-scope="scope">
                      <el-input v-model="scope.row['jiti1']"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" align="center">
                    <template slot-scope="{scope,$index}">
                      <button class="addrow" @click="addrow" style="color:#409eff;margin-right:10px">增加一行</button>
                      <button class="addrow" style="color:#409eff" @click="delerowjieti($index)">删除</button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div class="btnbox" style="margin-left:230px">
                <el-button type="primary" class="btn" @click="summit('ele')">保 存</el-button>
                <!-- <el-button  class="cancel">取 消</el-button> -->
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="水" name="2">
          <div class="itemsLeft">
            <div class="itemgrounp table-warp">
              <div class="btnbox_">
                <el-button type="primary" size="small" v-popover:tlAddPop @click="eleclick('add')">新增</el-button>
                <el-button type="success" size="small" @click="eleclick('edit')">编辑</el-button>
                <el-button type="info" size="small" @click="eleDeleteClick">删除</el-button>
              </div>
              <el-table border ref="singleTable2" :data="leftTableEle" highlight-current-row @row-click="rowselectChange" style="width:90%;margin-top:5px;">
                <template v-for="(item, index) in left_columns">
                  <el-table-column v-if="item.show != false" :key="index" :prop="item.prop" :label="item.label" :align="item.align?item.align:'center'" :formatter="item.formatter?item.formatter :null"></el-table-column>
                </template>
              </el-table>
            </div>
            <div class="itemgrounp">
              <el-form ref="form" :model="waterform" :inline="true" label-width="120px">
                <el-form-item label="单价">
                  <el-input v-model="waterform.unitPrice"></el-input>
                </el-form-item>
              </el-form>
              <div class="btnbox" style="margin-left:230px">
                <el-button type="primary" class="btn" @click="summit('water')">保 存</el-button>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="天然气" name="3">
          <div class="itemsLeft">
            <div class="itemgrounp table-warp">
              <div class="btnbox_">
                <el-button type="primary" size="small" v-popover:tlAddPop @click="eleclick('add')">新增</el-button>
                <el-button type="success" size="small" @click="eleclick('edit')">编辑</el-button>
                <el-button type="info" size="small" @click="eleDeleteClick">删除</el-button>
              </div>
              <el-table border ref="singleTable3" :data="leftTableEle" highlight-current-row @row-click="rowselectChange" style="width:90%;margin-top:5px;">
                <template v-for="(item, index) in left_columns">
                  <el-table-column v-if="item.show != false" :key="index" :prop="item.prop" :label="item.label" :align="item.align?item.align:'center'" :formatter="item.formatter?item.formatter :null"></el-table-column>
                </template>
              </el-table>
            </div>
            <div class="itemgrounp">
              <el-form ref="form" :model="lngform" :inline="true" label-width="120px">
                <el-form-item label="单价">
                  <el-input v-model="lngform.unitPrice"></el-input>
                </el-form-item>
              </el-form>
              <div class="btnbox" style="margin-left:230px">
                <el-button type="primary" class="btn" @click="summit('lng')">保 存</el-button>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
    <!-- 电弹窗 -->
    <el-dialog :title="eletitle" :visible.sync="alarm" width="45%" :close-on-click-modal="false" @close="formClose">
      <el-form label-width="130px" :model="eleaddform" :rules="rules" ref="eleaddform">
        <el-form-item label="时间:">
          <el-date-picker v-model="eleaddform.value1" value-format="yyyy/MM/dd HH:mm:ss" :unlink-panels="true" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
            ></el-date-picker>
        </el-form-item>
        <el-form-item label="计价模型:" prop="region">
          <el-select v-model="eleaddform.region" :disabled="disabled " placeholder="请选择活动区域">
            <el-option v-for="(item,index) in tanType" :key="index" :label="item.text" :value="item.type"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <!-- 峰平谷尖开始 -->
      <div class="elefeng" v-if="activeName=='1'&&eleaddform.region==1&&noModify">
        <div class="eletable table-warp">
          <p class="zt zt1">单价</p>
          <el-table :data="tableDataFpg" border :fit=true style="width: 100%" height="20%" highlight-current-row size="small">
            <el-table-column v-for="(item,index) in eleTopcolumnsNew" :key="index" :label="item.label" align="center">
              <template slot-scope="scope">
                <el-input v-model="scope.row['type'+index]"></el-input>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="eletable eletable_ table-warp">
          <p class="zt zt1">时段</p>
          <el-table :data="tableDataFpgTime" border :fit=true style="width:100%" height="250px" highlight-current-row size="small">
            <el-table-column v-for="(item,index) in eleBotcolumnsNew" :key="index" :label="item.label" align="center">
              <template slot-scope="scope">
                <el-time-picker v-if="index==0" v-model="scope.row['time'+index]" :picker-options="scope.row['time'+(index+1)]" value-format="HH:mm" format="HH:mm" placeholder="任意时间点">
                </el-time-picker>
                <el-time-picker v-if="index==1" v-model="scope.row['time'+index]" :picker-options="scope.row['time'+(index-1)]" value-format="HH:mm" format="HH:mm" placeholder="任意时间点">
                </el-time-picker>
                <el-select v-if="index==2" v-model="scope.row['time'+index]" placeholder="请选择活动区域">
                  <el-option label="峰" value="1"></el-option>
                  <el-option label="平" value="2"></el-option>
                  <el-option label="谷" value="3"></el-option>
                  <el-option label="尖" value="4"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="{row,$index}">
                <span class="addrow" @click="addrowtime('dig')">增加一行</span>
                <span class="addrow" @click="delerowtime($index,'dig')">删除</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <!-- 峰平谷尖结束 -->
      <!-- 商业开始 -->
      <div calss="elebuy" v-if="activeName=='1'&&eleaddform.region=='2'&&noModify||activeName=='2'&&eleaddform.region=='1'&&noModify
            ||activeName=='3'&&eleaddform.region=='1'&&noModify">
        <el-form ref="form" :model="elebuyformNew" label-width="80px">
          <el-form-item label="单价">
            <el-input style="width:218px;" v-model="elebuyformNew.unitPrice"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <!-- 商业结束 -->
      <!-- 阶梯开始 -->
      <div calss="jieti table-warp" v-if="activeName=='1'&&eleaddform.region=='3'&&noModify">
        <el-table :data="tableDataJt" border :fit=true style="width: 100%" height="400px" highlight-current-row size="small">
          <el-table-column label="阀值" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row['jiti0']"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="单价" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row['jiti1']"></el-input>
            </template>

          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="{scope,$index}">
              <span class="addrow" @click="addrow('dig')">增加一行</span>
              <span class="addrow" @click="delerowjieti($index,'dig')">删除</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 阶梯结束 -->
      <div slot="footer" class="dialog-footer" style="margin-right:210px">
        <el-button type="primary" @click="eleAddSave" class="btn">保 存</el-button>
        <el-button @click="alarm = false" class="cancel">取 消</el-button>
      </div>
    </el-dialog>

    <el-dialog title="分摊计价设置" :visible.sync="ftjjszVisible" :close-on-click-modal="false" width="1000px">
      <div class="ftjjsz-warp">
        <div class="btn-content dn-content-bg" style="text-align: left;">
          <el-button type="primary" @click="bindShowAddftjj">新增</el-button>
          <el-button type="primary" @click="bindShowAddftjjEdit">修改</el-button>
          <el-button type="danger" @click="bindShowdeletftjjEdit">删除</el-button>
        </div>
        <div class="top">
          <nk-table height="400px" :rowselect="true" :data="ftjjszTable" @handleRowClick="handleFtjjszRowClick" :columns="ftjjszColumns"></nk-table>
        </div>
        <div class="bottom">
          <div class="label">分摊公式</div>
          <div class="textarea">
            <el-input type="textarea" v-model="ftjjszRow.expression"></el-input>
          </div>
          <div class="btn-ftjjsz-content">
            <el-button type="primary" @click="editFtjjszSave">保存</el-button>
            <el-button type="primary" @click="ftjjszVisible=false">取消</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog :title="editFtjjszTitle" :visible.sync="editFtjjszVisible" :close-on-click-modal="false" width="900px">
      <el-form :model="rentalAreaPublicEnergyUsedSharingFrom" style="padding-top:30px;" ref="ftjjadd" label-position="left" label-width="130px">
        <el-form-item label="分摊名称:">
          <el-input v-model="rentalAreaPublicEnergyUsedSharingFrom.name" style="width:400px"></el-input>
        </el-form-item>
        <el-form-item label="能源类型:">
          <el-select v-model="rentalAreaPublicEnergyUsedSharingFrom.energyType" placeholder="请选择" style="width:400px">
            <el-option v-for="item in energyType1" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分摊时间:" :inline="true" class="demo-form-inline">
          <el-date-picker v-model="rentalAreaPublicEnergyUsedSharingFrom.startTime" value-format="yyyy/MM/dd HH:mm:ss" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :unlink-panels="true"></el-date-picker>
        </el-form-item>
        <el-form-item label="测量点:">
          <div>
            <span v-if="rentalAreaPublicEnergyUsedSharingFrom.measureId==null?false:true" style="margin-right:30px">ID:{{rentalAreaPublicEnergyUsedSharingFrom.measureId}}</span>
            <span v-if="rentalAreaPublicEnergyUsedSharingFrom.measureName==null?false:true" style="margin-right:30px">名称:{{rentalAreaPublicEnergyUsedSharingFrom.measureName}}</span>
            <el-button size="medium" @click="bindShowMeasureChoice">选择测量点</el-button>
          </div>
        </el-form-item>
        <el-form-item label="测量编码:">
          <el-select v-model="rentalAreaPublicEnergyUsedSharingFrom.pointCode" placeholder="请选择" class="select" clearable style="width:400px">
            <el-option v-for="(items,index) in bmData" :key="index" :label="items.name" :value="items.pointCode"></el-option>
          </el-select>
          <!-- <el-input v-model="rentalAreaPublicEnergyUsedSharingFrom.pointCode" style="width:400px"></el-input> -->
        </el-form-item>
        <el-form-item label="测量编号:">
          <el-input v-model="rentalAreaPublicEnergyUsedSharingFrom.pointNumber" style="width:400px"></el-input>
        </el-form-item>
        <el-form-item label="表达式:">
          <el-input type="textarea" v-model="rentalAreaPublicEnergyUsedSharingFrom.expression" style="width:400px"></el-input>
        </el-form-item>
        <el-form-item label="单价:">
          <el-input v-model="rentalAreaPublicEnergyUsedSharingFrom.unitPrice" style="width:400px"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="margin-right:350px">
        <el-button type="primary" @click="bindSaveRentalAreaPublicEnergyUsedSharing" class="btn">保 存</el-button>
        <el-button @click="editFtjjszVisible = false" class="cancel">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog title="选择测量点" :visible.sync="measureChoiceVisible" :close-on-click-modal="false" width="800px">
      <div class="choice-warp">
        <div class="choice-left">
          <el-tree :data="frameworkData" :props="defaultFrameworkProps" @node-click="bindNodeClick"></el-tree>
        </div>
        <div class="choice-right">
          <nk-table height="500px" :rowselect="true" :data="measureTable" @rowdblclick="handleFtjjszRowDoubleClick" @handleRowClick="handleFtjjszRowClick" :columns="measureColumns"></nk-table>
        </div>
      </div>
      <div slot="footer" class="dialog-footer" style="margin-right:300px">
        <el-button type="primary" @click="ftjjtree" class="btn">确 定</el-button>
        <el-button @click="measureChoiceVisible = false" class="cancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// import { creatMenuJson } from "@/utils/index.js";
import NkTable from "@/components/common/NkTable";
import { getPage } from "@/utils/index.js";
import tree from "@/utils/tree.js";
import * as utils from "@/utils/index.js";
import { isNull } from "util";
import dateTool from "@/utils/dateTool";
export default {
  components: { NkTable },
  data () {
    return {
      searchFt: {
        dates: ["", ""]
      },
      tableDataRen: [],
      treeTableData: [],
      defaultProps: {
        children: "children",
        label: "name"
      },
      columnsLeft: [
        //左边场地表格树
        // { prop: "id", width: 250, label: "id" },
        { prop: "name", label: "名称", align: "left" },
        { prop: "displayName", label: "显示名称", align: "left" },
        { prop: "place", label: "位置", align: "left" },
        { prop: "orderNum", label: "排序编号", align: "left" }
      ],
      columnsRight: [
        //右边场地参数表格
        { prop: "name", label: "名称", align: "left" },
        { prop: "displayName", label: "显示名称", align: "left" },
        { prop: "value", label: "参数", align: "left" }
      ],
      columns: [
        { prop: "id", width: 250, label: "id", align: "left" },
        { prop: "name", label: "名称", align: "left" },
        { prop: "place", label: "位置", align: "left" },
        { prop: "orderNum", label: "排序编号", align: "left" }
      ],
      noDis: false, //显示名称是否可删除
      tableData: [], //场地表格树
      rentalAreaData: [], //场地参数数据
      addRentalAreaGroupVisible: false,
      addRentalAreaGroupTitle: "",
      handleNode: null,
      parentName: "",
      rentalAreaGroupFrom: {},
      addRentalAreaVisible: false, //场地
      addRentalAreaTitle: "",
      addRentalAreaParamVisible: false, //场地参数
      addRentalAreaParamTitle: "",
      filterText: "",
      rentalAreaFrom: {
        //场地数据
        name: "",
        displayName: '',
        place: "",
        parentId: ""
      },
      rentalAreaFromParam: {
        //场地参数数据
        name: "",
        displayName: "",
        value: ""
      },
      selectRental: {}, //选中场地行
      selectRentalParam: {}, //选中场地参数行行
      //计量设置开始
      page: {
        //
        pageSizes: [10, 20, 50, 100, 500, 1000], //每页显示条目个数
        size: 10,
        pageIndex: 1,
        total: 0
      },
      search: {
        //计量新增时间段
        dates: ''
      },
      search1: {
        //计量编辑时间段
        dates: ''
      },
      selectRowJL: {}, //选中计量某行
      tableForm: "addForm",
      company: false,
      company1: false,
      title: "新增",
      type: "", //密码类型
      // 选项列表（必选）
      newList: [],
      jlData: [],
      endata: [
        { id: 1, name: "电" },
        { id: 2, name: "水" },
        { id: 3, name: "气" }
      ],
      energyType: 0,
      areaId: 1,
      formJL: {
        rentalAreaId: "", //场地id
        startTime: "", //开始时间
        endTime: "", //结束时间
        measureId: "", //测量点id
        measureName: "", //测量点名字
        pointCode: "", //测量编码
        pointNumber: "0", //测量编号
        energyType: "" //计量能源类型
      }, //新增计量表单内容
      upformJL: {
        measuringId: "", //计量id
        startTime: "", //开始时间
        endTime: "", //结束时间
        measureId: "", //测量点id
        measureName: "", //测量点名字
        pointCode: "", //测量编码
        pointNumber: "0", //测量编号
        energyType: "" //计量能源类型
      }, //编辑计量表单内容
      rules: {
        rentalAreaId: [
          {
            required: true,
            message: "请输入且为数字",
            trigger: ["blur", "change"]
          }
        ],
        measuringId: [
          {
            required: true,
            message: "请输入",
            trigger: ["blur", "change"]
          }
        ],
        startTime: [
          {
            required: true,
            message: "请选择",
            trigger: ["blur", "change"]
          }
        ],
        endTime: [
          {
            required: true,
            message: "请选择",
            trigger: ["blur", "change"]
          }
        ],
        measureId: [
          {
            required: true,
            message: "请选择",
            trigger: ["blur", "change"]
          }
        ],
        measureName: [
          {
            required: true,
            message: "请选择",
            trigger: ["blur", "change"]
          }
        ],
        pointNumber: [
          {
            required: true,
            message: "请输入",
            trigger: ["blur", "change"]
          }
        ],
        pointCode: [
          {
            required: true,
            message: "请输入",
            trigger: ["blur", "change"]
          }
        ],
        energyType: [
          {
            required: true,
            message: "请选择",
            trigger: ["blur", "change"]
          }
        ],
        region: [
          {
            required: true,
            message: "请选择计价模型",
            trigger: ["blur", "change"]
          }
        ],
        value1: [
          {
            type: "array",
            required: true,
            message: "请选择时间",
            trigger: ["blur", "change"]
          }
        ],
        name: [
          {
            required: true,
            message: "请输入名称",
            trigger: ["blur", "change"]
          }
        ],
        displayName: [
          {
            required: true,
            message: "请输入显示名称",
            trigger: ["blur", "change"]
          }
        ],
        place: [
          {
            required: true,
            message: "请输入位置",
            trigger: ["blur", "change"]
          }
        ],
        orderNum: [
          {
            required: true,
            message: "请输入排序编号",
            trigger: ["blur", "change"]
          }
        ],
        displayName: [
          {
            required: true,
            message: "请输入显示名称",
            trigger: ["blur", "change"]
          }
        ]
      },
      treetitle: "新增",
      treealarm: false, //测量点弹窗标题
      windowtreedata: [], //测量电弹窗树数据
      windowTreeRows: null, //
      treerightData: [], //测量点弹窗右边表格数据
      columnsJL: [
        //计量设置
        { prop: "id", label: "id", show: true },
        { prop: "name", label: "名称", show: true },
        { prop: "remark", label: "备注", show: true }
      ],
      treerightcolumns: [
        { prop: "id", label: "id", show: true },
        { prop: "name", label: "名称", show: true },
        { prop: "remark", label: "备注", show: true }
      ],
      treecolumns: [
        { prop: "measureName", label: "计量点名称", show: true, align: false },
        { prop: "measureRemark", label: "备注", show: true, align: true }
      ],
      rowselect: true, //设置表格单选
      treeTableRows: null,
      treeprop: {
        label: "name",
        children: "children"
      },
      right_data: [],
      bmData: [
        { pointCode: 100229, name: "正向有功总电能" },
        { pointCode: 100230, name: "反向有功总电能" },
        { pointCode: 100231, name: "正向无功总电能" },
        { pointCode: 100232, name: "反向无功总电能" },
        { pointCode: 100401, name: "总正向流量" },
        { pointCode: 100402, name: "总反向流量" },
        { pointCode: 100701, name: "计数" }
      ],
      companyJL: false, //计量设置弹窗
      companyJJ: false, //计量计价设置弹窗
      rentalSect: [], //场地下拉框
      //计量设置结束
      //计量计价开始
      activeName: "1",
      tableDataJLJJ: [{ time0: "", time1: "", time2: "" }],
      tableData2: [{ type0: "", type1: "", type2: "", type3: "" }],
      tableData3: [{ jiti0: "", jiti1: "" }],
      elebuyformNew: {
        unitPrice: ''
      },
      noModify: false,
      tableDataFpg: [{ type0: '', type1: '', type2: '', type3: '' }],
      tableDataFpgTime: [{ time0: '', time1: '', time2: '' }],
      tanType: window.baseConfig.costData[0].modes,
      tableDataF: [{ time0: '', time1: '', time2: '' }],
      search3: {
        //计量编辑时间段
        dates: ["", ""]
      },
      rowParam: {},
      eleBotcolumnsNew: [
        { id: 0, label: "开始时间", show: true },
        { id: 1, label: "结束时间", show: true },
        { id: 2, label: "峰平谷尖", show: true }
      ],
      eleTopcolumnsNew: [
        { id: 0, label: "峰", show: true, formatter: "formatterone" },
        { id: 1, label: "平", show: true },
        { id: 2, label: "谷", show: true },
        { id: 3, label: "尖", show: true },
      ],
      tableDataJt: [{ jiti0: '', jiti1: '' }],
      pageJLJJ: {
        pageSizes: [10, 20, 30, 40], //每页显示条目个数
        total: 50
      },
      left_columns: [
        { prop: "startDate", label: "开始时间", show: true },
        { prop: "endDate", label: "结束时间", show: true },
        {
          prop: "mode",
          label: "计价模型",
          show: true,
          formatter: this.Setformatter
        }
      ],
      eleBotcolumns: [
        { id: 0, label: "开始时间", show: true },
        { id: 1, label: "结束时间", show: true },
        { id: 2, label: "峰平谷尖", show: true }
      ],
      eleTopcolumns: [
        { id: 0, label: "峰", show: true, formatter: "formatterone" },
        { id: 1, label: "平", show: true },
        { id: 2, label: "谷", show: true },
        { id: 3, label: "尖", show: true }
      ],
      jieTicolumns: [
        { id: 0, label: "阀值", show: true },
        { id: 1, label: "单价", show: true }
      ],
      form: {
        region: "2"
      },
      elebuyform: {
        price: ""
      },
      waterform: {
        region: "2",
        unitPrice: ""
      },
      lngform: {
        region: "sahngye",
        unitPrice: ""
      },
      tb2: [
        { pervalue: "" },
        { pervalue: "" },
        { pervalue: "" },
        { pervalue: "" }
      ],
      eleUnitPrice: [], //获取电单价
      leftTableEle: [],
      eletitle: "新增",
      alarm: false,
      value1: [],
      eleaddform: {
        region: '',
        value1: []
      },
      selectRowsValue: null,
      rowselected: false,
      jjmode: [
        { id: 1, text: "峰平谷尖" },
        { id: 2, text: "商业" },
        { id: 3, text: "阶梯" }
      ],
      jjmode2: [{ id: 1, text: "商业" }],
      handltype: "", //新增还是编辑状态
      disabled: false,
      rentalAreaId: 0,
      //计量计价设置结束

      // rentalAreaFrom: {},
      //分摊计价设置
      ftjjszVisible: false,
      ftjjszColumns: [
        { prop: "id", label: "id", show: false },
        { prop: "startTime", label: "开始时间" },
        { prop: "endTime", label: "结束时间" },
        { prop: "name", label: "名称" },
        { prop: "measureId", label: "测量点id", show: false },
        { prop: "pointCode", label: "测量点编码" },
        { prop: "pointNumber", label: "测量点编号" },
        { prop: "unitPrice", label: "单价" }
      ],
      ftjjszTable: [],
      ftjjszRow: {},
      editFtjjszTitle: "",
      editFtjjszVisible: false,
      timeArr: [],
      rentalAreaPublicEnergyUsedSharingFrom: {},
      energyType1: [
        {
          value: "1",
          label: "电"
        },
        {
          value: "2",
          label: "水"
        },
        {
          value: "3",
          label: "天然气"
        }
      ],
      measureChoiceVisible: false,
      frameworkData: [],
      defaultFrameworkProps: {
        label: "name",
        children: "children"
      },
      measureTable: [],
      measureColumns: [
        { prop: "id", label: "id", show: false },
        { prop: "name", label: "测量点名称", width: 150 },
        { prop: "remark", label: "备注", width: 220 }
      ],
      companyId: "" //公司Id
    };
  },
  mounted () {
    this.getLeft();
  },
  created () {
    let vm = this;
    vm.getRentalArea(); //拿取场地表格树
  },
  watch: {
    filterText (val) {
      //关键字搜索
      this.$refs.tree.filter(val);
    },
    activeName () {
      this.rowselected = false; //选择状态职位false
      this.selectRowsValue = null; //选择的行清空
      this.leftTableEle = []; //左边表格清空
      if (this.activeName == 1) {
        this.tanType = window.baseConfig.costData[0].modes
      } else {
        console.log(window.baseConfig.costData)
        this.tanType = window.baseConfig.costData[1].modes
      }
      this.waterform.unitPrice = "";
      this.lngform.unitPrice = "";
      this.elebuyform.price = "";
      this.getCostType();
    }
  },
  methods: {
    handleNodeClick (data) {
      // this.getRentalArea();
      this.handleNode = data;
      this.rentalAreaFrom = {};
    },
    getRentalArea () {
      //拿取表格树
      let vm = this;
      vm.companyId = "0";
      let rentalAreaId;
      vm.$api.rentalArea
        .getRentalArea(this.$store.state.user.currentCompanyId)
        .then(res => {
          //拿取场地表格树
          vm.tableDataRen = utils.arrToTreeData(res.data, 0); //转为树格式
          let currentRow;
          function setCurrentRowCd (cdData1) {
            let cdData = JSON.parse(JSON.stringify(cdData1));
            cdData.forEach(item => {
              currentRow = cdData.find(obj => {
                return obj.id == vm.selectRental.id;
              });
              if (item.children.length > 0) {
                setCurrentRowCd(item.children);
              }
            });
            return currentRow;
          }
          vm.getRentalAreaParams(res.data[0].id); //拿取场地参数
        })
        .catch(error => {
          vm.$message.error(error.data.msg);
        });
      vm.selectRental = {};
      vm.rentalAreaFrom.id = "";
    },
    getRentalAreaParams (id) {
      //拿取场地参数数据
      let vm = this;
      vm.$api.rentalArea
        .getRentalAreaParams(id)
        .then(res => {
          //拿取场地参数数据
          vm.rentalAreaData = res.data;
          if (Object.keys(vm.selectRentalParam).length > 0) {
            let setCurrentRowXh = vm.rentalAreaData.find(obj => {
              return obj.name == vm.selectRentalParam.name;
            });
            vm.selectRentalParam = JSON.parse(JSON.stringify(setCurrentRowXh));
            vm.$refs.rentalAreaData.setCurrentRow(setCurrentRowXh); //选中某行
          }
        })
        .catch(error => {
          vm.$message.error(error.data.msg);
        });
    },
    bindShowAddRentalAreaGroup () {
      let vm = this;
      vm.addRentalAreaGroupTitle = "新增场地";
      if (Object.keys(vm.selectRow).length == 0) {
        vm.$message({
          message: "请选择你要新增的场地！",
          type: "warning"
        });
        return;
      }
      vm.addRentalAreaGroupVisible = true;
    },
    bindShowEditRentalAreaGroup () {
      let vm = this;
      vm.addRentalAreaGroupTitle = "修改场地组";
      if (vm.handleNode) {
        vm.rentalAreaGroupFrom = vm.handleNode;
        vm.rentalAreaGroupFrom.groupId = vm.handleNode.id;
        vm.addRentalAreaGroupVisible = true;
      } else {
        vm.$message({
          message: "请选择要修改的场地组",
          type: "warning"
        });
      }
    },
    addRentalAreaGroup () {
      let vm = this;
      if (
        !vm.rentalAreaGroupFrom.name ||
        vm.rentalAreaGroupFrom.name.length == 0
      ) {
        vm.$message({
          message: "请输入场地组名称！",
          type: "warning"
        });
        return;
      }
      //新增
      if (!vm.rentalAreaGroupFrom.groupId) {
        let item = vm.treeTableData.find(
          obj => obj.name == vm.rentalAreaGroupFrom.name
        );
        if (item) {
          vm.$message({
            message: "场地组名称重复！请重新输入",
            type: "warning"
          });
          return;
        }
        vm.$api.rentalArea
          .addRentalAreaGroup(
            vm.rentalAreaGroupFrom.name,
            vm.rentalAreaGroupFrom.parentId,
            vm.rentalAreaGroupFrom.orderNum
          )
          .then(res => {
            if (res) {
              vm.$message("新增场地组成功！");
              vm.getTreeData();
              vm.addRentalAreaGroupVisible = false;
            }
          });
      } else {
        let item = vm.treeTableData.find(
          obj =>
            obj.name == vm.rentalAreaGroupFrom.name &&
            obj.id != vm.rentalAreaGroupFrom.groupId
        );
        if (item) {
          vm.$message({
            message: "场地组名称重复！请重新输入",
            type: "warning"
          });
          return;
        }
        vm.$api.rentalArea
          .modifyRentalAreaGroup(
            vm.rentalAreaGroupFrom.groupId,
            vm.rentalAreaGroupFrom.name,
            vm.rentalAreaGroupFrom.parentId,
            vm.rentalAreaGroupFrom.orderNum
          )
          .then(res => {
            if (res) {
              vm.$message("修改场地组成功！");
              vm.getTreeData();
              vm.addRentalAreaGroupVisible = false;
            }
          });
      }
    },
    handleRowClickAental (row) {
      //点击场地表格
      //场地表格点击行
      let vm = this;
      row = isNull(row) ? {} : row;
      if (Object.keys(row).length > 0) {
        vm.selectRental = row;
        vm.rentalAreaFrom.id = row.id;
        vm.areaId = vm.rentalAreaFrom.id;
        this.rentalAreaId = vm.rentalAreaFrom.id;
        vm.$api.rentalArea
          .getRentalAreaParams(row.id)
          .then(res => {
            //拿取场地参数数据
            if (res.success) {
              vm.rentalAreaData = res.data;
            }
          })
          .catch(error => {
            vm.$message.error(error.data.msg);
          });
      }
    },
    handleRowClickAentalParam (row) {
      //点击场地参数表格
      //场地表格点击行
      let vm = this;
      row = isNull(row) ? {} : row;
      if (Object.keys(row).length > 0) {
        vm.selectRentalParam = row;
        vm.areaId = vm.rentalAreaFrom.id;
        vm.rentalAreaId = vm.rentalAreaFrom.id;
      }
    },
    bindShowAddRentalArea (type) {
      //场地新增编辑
      let vm = this;
      console.log(vm.rentalAreaFrom)
      vm.rentalAreaFrom.name = "";
      vm.rentalAreaFrom.displayName = "";
      vm.rentalAreaFrom.place = "";
      vm.rentalAreaFrom.orderNum = 1;
      if (type == "add") {
        //新增
        console.log(vm.tableDataRen.length == 0)
        if (vm.tableDataRen.length == 0) {
          vm.rentalAreaFrom.parentId = '0';
          console.log(vm.rentalAreaFrom.parentId)
        } else {
          if (Object.keys(vm.selectRental).length == 0) {
            vm.$message({
              message: "请选择你要新增的场地！",
              type: "warning"
            });
            return;
          }
          vm.rentalAreaFrom.parentId = vm.selectRental.id;
        }

        vm.addRentalAreaTitle = "新增场地";

      } else {
        if (Object.keys(vm.selectRental).length == 0) {
          vm.$message({
            message: "请选择你要编辑的场地！",
            type: "warning"
          });
          return;
        }
        vm.addRentalAreaTitle = "修改场地";
        vm.rentalAreaFrom.orderNum = vm.selectRental.orderNum;
        vm.rentalAreaFrom.name = vm.selectRental.name;
        vm.rentalAreaFrom.displayName = vm.selectRental.displayName;
        vm.rentalAreaFrom.place = vm.selectRental.place;
        vm.rentalAreaFrom.parentId = vm.selectRental.parentId;
      }
      vm.addRentalAreaVisible = true;
    },
    addRentalArea () {
      //新增编辑场地
      let vm = this;
      vm.$refs["rentalAreaFrom"].validate(valid => {
        if (valid) {
          let backres;
          console.log(vm.rentalAreaFrom)
          if (vm.addRentalAreaTitle == "新增场地") {
            backres = vm.$api.rentalArea.addRentalArea(
              "0",
              vm.rentalAreaFrom.name,
              vm.rentalAreaFrom.displayName,
              vm.rentalAreaFrom.place,
              vm.rentalAreaFrom.orderNum,
              vm.rentalAreaFrom.parentId
            );
          } else {
            backres = vm.$api.rentalArea.modifyRentalArea(
              vm.selectRental.id,
              vm.rentalAreaFrom.name,
              vm.rentalAreaFrom.displayName,
              vm.rentalAreaFrom.place,
              vm.rentalAreaFrom.orderNum,
              vm.rentalAreaFrom.parentId
            );
          }
          backres
            .then(res => {
              if (res.success) {
                if (vm.addRentalAreaTitle == "新增场地") {
                  vm.$message.success("新增成功！");
                } else {
                  vm.$message.success(res.msg);
                }
                vm.getRentalArea();
                vm.addRentalAreaVisible = false;
              } else {
                return;
              }
            })
            .catch(error => {
              vm.$message.error(error.data.msg);
            });
        }
      });
    },
    delRentalArea () {
      //删除场地
      let vm = this;
      if (Object.keys(vm.selectRental).length != 0) {
        this.$confirm("是否删除您选中的场地?", "系统提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            vm.$api.rentalArea
              .deleteRentalArea(vm.selectRental.id)
              .then(res => {
                if (res) {
                  vm.$message.success("删除场地成功！");
                  // vm.getRentalArea(vm.handleNode.id);
                  vm.getRentalArea();
                  vm.selectRental = {};
                }
              });
          })
          .catch(() => { });
      } else {
        vm.$message({
          message: "请选择您要删除的场地！",
          type: "warning"
        });
      }
    },
    bindShowAddRentalAreaParam (type) {
      //场地参数新增编辑
      let vm = this;
      vm.rentalAreaFromParam.rentalAreaId = vm.selectRental.id;
      if (type == "add") {
        if (Object.keys(vm.selectRental).length == 0) {
          vm.$message({
            message: "请选择你要新增的场地！",
            type: "warning"
          });
          return;
        }
        vm.noDis = false;
        vm.addRentalAreaParamTitle = "新增场地参数";
        vm.rentalAreaFromParam.name = "";
        vm.rentalAreaFromParam.displayName = "";
        vm.rentalAreaFromParam.value = "";
      } else {
        if (Object.keys(vm.selectRental).length == 0) {
          vm.$message({
            message: "请选择你要编辑的场地！",
            type: "warning"
          });
          return;
        }
        vm.noDis = true;
        vm.selectRentalParam = isNull(vm.selectRentalParam)
          ? {}
          : vm.selectRentalParam;
        if (Object.keys(vm.selectRentalParam).length == 0) {
          vm.$message({
            message: "请选择你要编辑的场地参数！",
            type: "warning"
          });
          return;
        }
        vm.addRentalAreaParamTitle = "修改场地参数";
        vm.rentalAreaFromParam.name = vm.selectRentalParam.name;
        vm.rentalAreaFromParam.displayName = vm.selectRentalParam.displayName;
        vm.rentalAreaFromParam.value = vm.selectRentalParam.value;
      }
      vm.addRentalAreaParamVisible = true;
    },
    addRentalAreaParam () {
      //新增编辑场地参数
      let vm = this;
      vm.$refs["rentalAreaFromParam"].validate(valid => {
        if (valid) {
          let backres;
          if (vm.addRentalAreaParamTitle == "新增场地参数") {
            backres = vm.$api.rentalArea.addRentalAreaParam(
              vm.selectRental.id,
              vm.rentalAreaFromParam.name,
              vm.rentalAreaFromParam.displayName,
              vm.rentalAreaFromParam.value
            );
          } else {
            backres = vm.$api.rentalArea.modifyRentalAreaParam(
              vm.selectRental.id,
              vm.rentalAreaFromParam.name,
              vm.rentalAreaFromParam.displayName,
              vm.rentalAreaFromParam.value
            );
          }
          backres
            .then(res => {
              if (res.success) {
                if (vm.addRentalAreaParamTitle == "新增场地参数") {
                  vm.$message.success("新增成功！");
                } else {
                  vm.$message.success(res.msg);
                }
                vm.addRentalAreaParamVisible = false;
              } else {
                return;
              }
              vm.getRentalAreaParams(vm.selectRental.id);
            })
            .catch(error => {
              vm.$message.error(error.data.msg);
            });
        }
      });
    },
    delRentalAreaParam () {
      //删除场地参数
      let vm = this;
      if (Object.keys(vm.selectRental).length == 0) {
        vm.$message({
          message: "请选择你要删除的场地！",
          type: "warning"
        });
        return;
      }
      vm.noDis = true;
      if (Object.keys(vm.selectRentalParam).length == 0) {
        vm.$message({
          message: "请选择你要删除的场地参数！",
          type: "warning"
        });
        return;
      }
      this.$confirm("是否删除您选中的场地?", "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          vm.$api.rentalArea
            .deleteRentalAreaParam(
              vm.selectRental.id,
              vm.selectRentalParam.name
            )
            .then(res => {
              if (res) {
                vm.$message.success("删除场地成功！");
                vm.selectRentalParam = {};
                vm.getRentalAreaParams(vm.selectRental.id);
              }
            });
        })
        .catch(() => { });
    },
    formCloserental () {
      //场地弹窗清除验证
      //计量新增弹窗关闭时
      this.$refs["rentalAreaFrom"].resetFields(); //清楚验证
      this.rentalAreaFrom = {
        //场地数据
        name: "",
        place: "",
        parentId: ""
      };
    },
    formCloserentalParam () {
      //场地参数弹窗清除验证
      //计量新增弹窗关闭时
      this.$refs["rentalAreaFromParam"].resetFields(); //清楚验证
      this.rentalAreaFromParam = {
        //场地参数数据
        name: "",
        displayName: "",
        value: ""
      };
    },
    //计量设置开始
    jlsz () {
      let vm = this;
      if (vm.rentalAreaFrom.id) {
        this.companyJL = true;
        this.getData(1);
      } else {
        vm.$message({
          message: "请选择您要查看计量设置的场地！",
          type: "warning"
        });
      }
    },
    getData (pageIndex) {
      //查询计量接口
      let vm = this;
      Promise.all([
        vm.$api.rentalArea.getRentalAreaEnergyUsedMeasuring1(
          vm.areaId,
          vm.energyType
        ) //获取计量列表
      ]).then(res => {
        let userPage = utils.toPage(res[0].data, pageIndex, vm.page.size);
        vm.jlData = userPage.arr;
        vm.page.total = userPage.total;
        vm.page.pageIndex = pageIndex;
        let setCurrentRowXh = vm.jlData.find(obj => {
          return obj.id == vm.selectRowJL.id;
        });
        vm.$refs.jlData.setCurrentRow(setCurrentRowXh); //选中某行
      });
    },
    metertypechangeC (val) {
      //匹配测量点编码
      if (val.pointCode == 100229) {
        return "正向有功总电能";
      } else if (val.pointCode == 100230) {
        return "反向有功总电能";
      } else if (val.pointCode == 100231) {
        return "正向无功总电能";
      } else if (val.pointCode == 100232) {
        return "反向无功总电能";
      } else if (val.pointCode == 100401) {
        return "总正向流量";
      } else if (val.pointCode == 100402) {
        return "总反向流量";
      } else if (val.pointCode == 100701) {
        return "计数";
      }
    },
    metertypechangeE (val) {
      //匹配能源类型
      if (val.energyType == 1) {
        return "电";
      } else if (val.energyType == 2) {
        return "水";
      } else if (val.energyType == 3) {
        return "气";
      }
    },
    handleSizeChange (val) {
      //调整每页显示数
      this.page.size = val;
      this.getData(1);
    },
    //上下一页
    handleCurrentChange (val) {
      this.getData(val);
    },
    selectBCl () {
      //编辑选择测量点
      this.windowtreedata = [];
      this.treerightData = []; //天窗右表清空
      this.treeTableRows = null;
      this.treealarm = true;
      this.treetitle = "编辑";
      let companyId = 0;
      this.$api.orgStructNode.getORGStructNodes(this.$store.state.user.currentCompanyId).then(res => {
        if (res.success) {
          this.windowtreedata = this.settreeData(res.data, 0);
        }
      });
    },
    selectACl () {
      //新增选择测量点
      this.windowtreedata = [];
      this.treerightData = []; //天窗右表清空
      this.treeTableRows = null;
      this.treealarm = true;
      this.treetitle = "新增";
      let companyId = 0;
      this.$api.orgStructNode.getORGStructNodes(this.$store.state.user.currentCompanyId).then(res => {
        if (res.success) {
          this.windowtreedata = this.settreeData(res.data, 0);
        }
      });
    },
    handleNodeClickJL (node) {
      //左边树点击事件
      this.windowTreeRows = node;
      let nodeId = node.id;
      this.treerightData = [];
      this.$api.orgStructNode.getMountedMeasures(nodeId).then(res => {
        this.treerightData = res.data;
      });
    },
    treerightselectChange (val) {
      //选择测量点弹窗表格行
      this.treeTableRows = val;
    },
    //双击一行
    treerowdblclick (val) {
      this.treeTableRows = val;
    },
    qxTree () {
      //取消树弹窗
      this.treealarm = false;
      this.upformJL.measureName = this.selectRowJL.measureName;
      this.upformJL.measureId = this.selectRowJL.measureId;
      this.formJL.measureName = "";
      this.formJL.measureId = "";
    },
    treesave () {
      //测量点弹窗保存
      if (!this.windowTreeRows || !this.treeTableRows) {
        this.$notify({
          title: "提示",
          message: "请选择信息！",
          type: "warning"
        });
        return;
      }
      this.treealarm = false;
      if (this.treetitle == "新增") {
        this.formJL.measureName = this.treeTableRows.name;
        this.formJL.measureId = this.treeTableRows.id;
      } else {
        this.upformJL.measureName = this.treeTableRows.name;
        this.upformJL.measureId = this.treeTableRows.id;
      }
    },
    settreeData (test, parentId) {
      let arr = [];
      for (let i in test) {
        if (test[i].parentId == parentId) {
          let obj = test[i];
          obj.children = this.settreeData(test, test[i].id);
          arr.push(obj);
        }
      }
      return arr;
    },
    getLeft () {
      //左边表格
      this.$api.view.getCompanyViewTreesInfo(this.$store.state.user.currentCompanyId).then(res => {
        if (!res.success) {
          return;
        }
        this.tableDataJLJJ = res.data;
        if (this.tableDataJLJJ.length > 0) {
          this.selectedRow = this.tableDataJLJJ[0];
          this.tableedit = true;
        }
      });
    },
    getRightTreeData (id) {
      //请求右边树数据
      this.$api.view.getViewTreeNodes(id).then(res => {
        if (res.success) {
          this.right_data = Object.assign([], res.data);
          let temp = JSON.parse(JSON.stringify(res.data));
        }
      });
    },
    update () {
      //修改
      let vm = this;
      if (Object.keys(vm.selectRowJL).length == 0) {
        vm.$message({
          message: "请选择你要修改的计量！",
          type: "warning"
        });
        return;
      }
      vm.upformJL.measuringId = vm.selectRowJL.id;
      vm.search1.dates = ['', ''];
      if (isNull(vm.selectRowJL.startTime)) {
        vm.selectRowJL.startTime = '';
      }
      if (isNull(vm.selectRowJL.endTime)) {
        vm.selectRowJL.endTime = '';
      }
      vm.search1.dates[0] = vm.selectRowJL.startTime;
      vm.search1.dates[1] = vm.selectRowJL.endTime;
      vm.upformJL.measureId = vm.selectRowJL.measureId;
      vm.upformJL.measureName = vm.selectRowJL.measureName;
      vm.upformJL.pointCode = vm.selectRowJL.pointCode;
      vm.upformJL.pointNumber = "0";
      vm.upformJL.energyType = vm.selectRowJL.energyType;
      vm.company1 = true;
    },
    add (data) {
      //新增
      this.title = "新增";
      this.search = {
        //计量编辑时间段
        dates: ''
      },
        (this.company = true),
        (this.formJL = {
          rentalAreaId: this.rentalAreaFrom.id, //场地id
          startTime: "", //开始时间
          endTime: "", //结束时间
          measureId: "", //测量点id
          pointCode: "", //测量编码
          pointNumber: "0", //测量编号
          energyType: "" //计量能源类型
        });
    },
    qxJLAdd (formName) {
      //取消计量设置新增
      this.company = false;
      this.$refs[formName].resetFields(); //清楚验证
    },
    qxJLUp (formName) {
      //取消计量设置编辑
      this.company1 = false;
      this.$refs[formName].resetFields(); //清楚验证
    },
    SaveJL () {
      //计量设置新增保存
      let vm = this;
      if (!vm.formJL.measureName || vm.formJL.measureName == "") {
        vm.$message({
          message: "请选择测量点名称！",
          type: "warning"
        });
        return;
      }
      vm.$refs["addForm"].validate(valid => {
        if (valid) {
          let startDate = "";
          let endDate = "";
          startDate = dateTool.format(
            new Date(vm.search.dates[0]),
            "yyyy-MM-dd hh:mm:ss"
          );
          endDate = dateTool.format(
            new Date(vm.search.dates[1]),
            "yyyy-MM-dd hh:mm:ss"
          );
          vm.$api.rentalArea
            .addRentalAreaEnergyUsedMeasuring(
              vm.formJL.rentalAreaId,
              startDate,
              endDate,
              vm.formJL.measureId,
              vm.formJL.pointCode,
              vm.formJL.pointNumber,
              vm.formJL.energyType
            )
            .then(res => {
              if (res.success) {
                vm.getData(1);
                vm.company = false;
              } else {
                return;
              }
            })
            .catch(error => {
              vm.$message.error(error.data.msg);
            });
        } else {
          return false;
        }
      });
    },
    upSaveJL () {
      //计量设置编辑保存
      let vm = this;
      if (!vm.upformJL.measureName || vm.upformJL.measureName == "") {
        vm.$message({
          message: "请选择测量点名称！",
          type: "warning"
        });
        return;
      }
      vm.$refs["updateForm"].validate(valid => {
        if (valid) {
          let startDate = ''
          let endDate = ''
          if (vm.selectRowJL.startTime) {
            startDate = dateTool.format(
              new Date(vm.search1.dates[0]),
              "yyyy-MM-dd hh:mm:ss"
            );
          }
          if (vm.selectRowJL.endTime) {
            endDate = dateTool.format(
              new Date(vm.search1.dates[1]),
              "yyyy-MM-dd hh:mm:ss"
            );
          }
          vm.$api.rentalArea
            .modifyRentalAreaEnergyUsedMeasuring(
              vm.upformJL.measuringId,
              startDate,
              endDate,
              vm.upformJL.measureId,
              vm.upformJL.pointCode,
              vm.upformJL.pointNumber,
              vm.upformJL.energyType
            )
            .then(res => {
              vm.getData(1);
              vm.$message.success(res.msg);
              vm.company1 = false;
            })
            .catch(error => {
              vm.$message.error(error.data.msg);
            });
        } else {
          return false;
        }
      });
    },
    checkNum (email, phone) { },
    del (data) {
      //删除操作
      let vm = this;
      if (Object.keys(vm.selectRowJL).length == 0) {
        vm.$message({
          message: "请选择你要删除的计量！",
          type: "warning"
        });
        return false;
      }
      this.$confirm("是否删除您选中的计量?", "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        vm.$api.rentalArea
          .deleteRentalAreaEnergyUsedMeasuring(vm.selectRowJL.id)
          .then(res => {
            vm.getData(1);
            vm.$message.success(res.msg);
          })
          .catch(error => {
            vm.$message.error(error.data.msg);
          });
      });
    },
    bindTreeNode (node) { },
    formCloseJL () {
      this.selectRowJL = {};
    }, //计量设置窗口
    formCloseJLAdd () {
      //计量新增弹窗关闭时
      this.$refs["addForm"].resetFields(); //清楚验证
      this.formJL = {
        rentalAreaId: "", //场地id
        startTime: "", //开始时间
        endTime: "", //结束时间
        measureId: "", //测量点id
        measureName: "", //测量点名字
        pointCode: "", //测量编码
        pointNumber: "", //测量编号
        energyType: "" //计量能源类型
      };
    },
    formCloseJLUpdate () {
      //计量编辑弹窗关闭时
      this.$refs["updateForm"].resetFields(); //清楚验证
    },
    // 取值
    getValue (value) {
      this.ORGStructNodeId = value;
    },
    metertypechange (val) {
      if (val.disabled == 1) {
        return "是";
      } else if (val.disabled == 2) {
        return "否";
      }
    },
    handleCurrentChangeJL (row) {
      //计量表格选择一行
      let vm = this;
      if (row) {
        vm.selectRowJL = row;
      }
    },
    change (e) {
      this.$forceUpdate();
    },
    formClosetree () { },
    //计量设置结束
    //计量计价设置开始
    jljjsz () {
      let vm = this;
      if (vm.rentalAreaFrom.id) {
        this.companyJJ = true;
        this.getCostType();
      } else {
        vm.$message({
          message: "请选择您要查看计量设置的场地！",
          type: "warning"
        });
      }
    },
    getCostType () {
      let this_ = this
      let companyId = 0, energyType = this.activeName
      this.$api.cost.getCompanyPricingModeOfEnergyCost(this.$store.state.user.currentCompanyId, energyType).then(res => {
        if (!res.success) {
          return
        }
        this_.leftTableEle = res.data
        console.log(this.rowselected)
        console.log(this.selectRowsValue)
        console.log(!this.selectRowsValue && !this.rowselected)
        if (!this.rowselected && !this.selectRowsValue) {
          console.log(res.data)
          this.serRowClick(res.data[0])
        }
      })
    },
    getBusiness () {
      //电=》商业单价
      let pricingRegulationId = this.selectRowsValue.id;
      this.$api.cost
        .getCompanyElectricityPricingMode2(pricingRegulationId)
        .then(res => {
          this.elebuyform.price = res.data.unitPrice;
        });
    },
    eleclick (type) {
      this.handltype = type
      this.eleaddform = { region: '', value1: [] }
      console.log("操作")
      console.log(type)
      if (type == "add") {
        this.eletitle = '新增'
        this.noModify = true
        this.alarm = true
        this.disabled = false
        this.tableDataFpg = [{ type0: '', type1: '', type2: '', type3: '' }],
          this.tableDataFpgTime = [{ time0: '', time1: '', time2: '' }],
          this.tableDataJt = [{ jiti0: '', jiti1: '' }],
          this.elebuyformNew = {
            unitPrice: ""
          }
      } else {
        console.log(2222)
        if (!this.rowselected) {
          this.showMsg("请选择要编辑的信息！")
          return
        }
        this.eletitle = '编辑'
        this.noModify = false
        this.disabled = true
        console.log(this.selectRowsValue)
        this.eleaddform.region = this.selectRowsValue.mode
        this.eleaddform.value1 = this.selectRowsValue.startDate != null ? Array.of(this.selectRowsValue.startDate, this.selectRowsValue.endDate) : ""
        this.alarm = true
      }
      if (this.$refs['eleaddform']) {
        this.$refs['eleaddform'].resetFields();
      }
    },
    eleDeleteClick () {
      let this_ = this
      if (!this.rowselected) {
        this.showMsg("请选择要删除的信息！")
        return
      }
      this.$confirm('确认删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let pricingRegulationId = this_.selectRowsValue.id
        this_.$api.cost.deleteCompanyPricingModeOfEnergyCost(pricingRegulationId).then(res => {
          this_.showMsg(res.msg)
          if (!res.success) {
            return
          }
          this_.waterform.unitPrice = null
          this_.lngform.unitPrice = null
          this_.form.region = null
          this_.selectRowsValue = null
          this_.getCostType()
        })
      })
    },
    Setformatter (row, column, cellValue) {
      let value = cellValue;
      let temparr = [];
      if (this.activeName == 1) {
        temparr = JSON.parse(JSON.stringify(this.jjmode));
      } else {
        temparr = JSON.parse(JSON.stringify(this.jjmode2));
      }
      let temp = temparr.find((val, index) => {
        return cellValue == val.id;
      });
      if (temp) {
        value = temp.text;
      }
      return value;
    },
    rowselectChange (val) {
      this.rowselected = true
      this.serRowClick(val)
    },
    serRowClick (val) {
      let this_ = this
      this.rowParam = JSON.parse(val.pricingModelParams)
      this.selectRowsValue = val
      this.form.region = val.mode
      if (!this.rowselected && !this.selectRowsValue && this.leftTableEle.length != 0) {
        let val = this_.leftTableEle[0]
        this_.selectRowsValue = val
        this_.form.region = val.mode
        this_.rowselected = true
        this_.$refs.singleTable1.setCurrentRow(this_.leftTableEle[0]);
        this_.$refs.singleTable2.setCurrentRow(this_.leftTableEle[0]);
        this_.$refs.singleTable3.setCurrentRow(this_.leftTableEle[0]);
      }
      console.log(this.activeName)
      console.log(this.form.region)
      if (this.activeName == "1") { //电、峰评估的
        if (this.form.region == "1") {
          this.getElePeak()
        } else if (this.form.region == "2") {//电、商业的
          this.getEleBusiness()
        } else {
          this.getLadder()
        }
      } else if (this.activeName == "2") {
        this.getWaterPrice() //查水单价
      } else if (this.activeName == "3") {
        console.log(3333)
        this.getLngPrice()  //查气单价
      }
    },
    getElePeak () {
      //电、峰平谷尖的数据获取
      let pricingRegulationId = this.selectRowsValue.id
      let temp = [{ type0: '', type1: '', type2: '', type3: '' }]
      temp[0].type0 = this.rowParam.unitPrice.peak
      temp[0].type1 = this.rowParam.unitPrice.plain
      temp[0].type2 = this.rowParam.unitPrice.valley
      temp[0].type3 = this.rowParam.unitPrice.sharp
      this.tableData2 = temp
      let testdata = this.rowParam.timeSegment
      let arr = []
      /* 峰 */
      this.getFPG(arr, testdata.peak, '1')
      /* 平 */
      this.getFPG(arr, testdata.plain, '2')
      /* 谷 */
      this.getFPG(arr, testdata.valley, '3')
      /* 尖 */
      arr = this.getFPG(arr, testdata.sharp, '4')
      if (arr.length == 0) {
        arr = [{ time0: '', time1: '', time2: '' }]
      }
      this.tableDataF = arr
    },
    /* h获取峰平谷数据  type确定峰平谷尖哪种数据 */
    getFPG (arr, res, type) {
      res.forEach(item => {
        arr.push({
          ["time0"]: item.startTime,
          ["time1"]: item.endTime,
          ["time2"]: type,
        })
      })
      return arr
    },
    getEleBusiness () {
      //查询电的商业
      this.elebuyform.unitPrice = this.rowParam.unitPrice
    },
    getLadder () {
      //查询电的阶梯
      let temp = this.rowParam.map(v => {
        return { jiti0: v.thresholdValue, jiti1: v.unitPrice }
      })
      if (temp.length == 0) {
        temp = [{ jiti0: '', jiti1: '' }]
      }
      this.tableData3 = temp
    },
    getWaterPrice () {
      //查询水单价
      this.waterform = this.rowParam
      if (!this.rowParam) {
        this.waterform = {
          region: '2',
          unitPrice: ''
        }
      }
    },
    getLngPrice () {
      //查询天然气单价
      this.lngform = this.rowParam
      if (!this.rowParam) {
        this.waterform = {
          region: 'sahngye',
          unitPrice: ''
        }
      }
    },
    eleAddSave () {
      //电单价保存
      let vm = this;
      this.$refs['eleaddform'].validate(async (valid) => {
        if (valid) {
          if (this.handltype == 'add') {
            let companyId = "0"
            let rentalAreaId = "0"
            let energyType = this.activeName
            let mode = this.eleaddform.region
            let startDate = this.eleaddform.value1[0]
            let endDate = this.eleaddform.value1[1]
            console.log(111111111)
            let obj = this.getParams(this.eleaddform.region, this.tableDataFpg[0], this.tableDataFpgTime, this.elebuyformNew, this.tableDataJt, this.elebuyformNew, this.elebuyformNew)
            let res = await this.$api.cost.addCompanyPricingModeOfEnergyCost(this.$store.state.user.currentCompanyId, rentalAreaId, energyType, mode, obj, startDate, endDate)
            console.log(res)
            this.getDataAfter(res)
          } else { //编辑计价模式
            let pricingRegulationId = this.selectRowsValue.id
            console.log(this.eleaddform.value1)
            let startDate = this.eleaddform.value1[0]
            let endDate = this.eleaddform.value1[1]
            let res = await this.$api.cost.modifyCompanyPricingModeOfEnergyCost(pricingRegulationId, startDate, endDate)
            this.getDataAfter(res)
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    /* 获取参数格式的数据  region计价模型 fUnitPrice  峰平谷单价 fTimeData  峰平谷时段    business 电商业数据  phase阶段数据 waterBusiness 水商业数据
    lingBusiness 气商业数据 */
    getParams (region, fUnitPrice, fTimeData, business, phase, waterBusiness, lingBusiness) {
      console.log(lingBusiness)
      let obj = {
        timeSegment: {
          peak: [],//峰
          plain: [],//平
          valley: [],//谷
          sharp: [],//尖
        },
        unitPrice: {
          peak: fUnitPrice.type0,
          plain: fUnitPrice.type1,
          valley: fUnitPrice.type2,
          sharp: fUnitPrice.type3
        }
      }
      if (this.activeName == "1") {
        if (region == '1') {
          fTimeData.forEach(item => {
            if (item.time2 == '1') {
              obj.timeSegment.peak.push({
                startTime: item.time0,
                endTime: item.time1
              })
            } else if (item.time2 == '2') {
              obj.timeSegment.plain.push({
                startTime: item.time0,
                endTime: item.time1
              })
            } else if (item.time2 == '3') {
              obj.timeSegment.valley.push({
                startTime: item.time0,
                endTime: item.time1
              })
            } else {
              obj.timeSegment.sharp.push({
                startTime: item.time0,
                endTime: item.time1
              })
            }
          })
        } else if (region == '2') {
          obj = business
        } else {
          obj = []
          phase.forEach(item => {
            obj.push({
              thresholdValue: item.jiti0,
              unitPrice: item.jiti1
            })
          })
        }
      }
      else if (this.activeName == "2") { //水
        obj = waterBusiness
      } else {
        obj = { unitPrice: lingBusiness.unitPrice }
      }
      return obj
    },
    inputchange () { },
    formClose () { },
    handleClick (tab, event) {
      //计量设置电水，天然气tabs切换
    },
    addrow (type) {
      if (type == "dig") {//弹窗内
        this.tableDataJt.push({ time0: '', time1: '', time2: '' })
      } else {
        this.tableData3.push({ jiti0: '', jiti1: '' })
      }
    },//新增一行
    addrowtime (type) {
      if (type == "dig") {//弹窗内
        this.tableDataFpgTime.push({ time0: '', time1: '', time2: '' })
      } else {
        this.tableDataF.push({ time0: '', time1: '', time2: '' })
      }
    },
    delerowtime (row) {
      if (type == "dig") {//弹窗内
        if (this.tableDataFpgTime.length == 1) {
          return
        }
      } else {
        this.tableData.push({ time0: '', time1: '', time2: '' })
        if (this.tableDataF.length == 1) {
          return
        }
      }

      this.$confirm('确认删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (type == "dig") {//弹窗内
          this.tableDataFpgTime.splice(row, 1)
        } else {
          this.tableDataF.splice(row, 1)
          this.deleTimeRow()
        }
      })
    },
    delerowjieti (row, type) {
      if (type == "dig") {//弹窗内
        if (this.tableDataJt.length == 1) {
          return
        }
      } else {
        this.tableData.push({ time0: '', time1: '', time2: '' })
        if (this.tableData3.length == 1) {
          return
        }
      }
      this.$confirm('确认删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (type == "dig") {//弹窗内
          this.tableDataJt.splice(row, 1)
        } else {
          this.tableData3.splice(row, 1)
        }
      })
    },
    summit (type) {
      if (!this.selectRowsValue || this.selectRowsValue.length == 0) {
        this.showMsg("请先选择计价模型")
        return
      }
      console.log(this.selectRowsValue)
      let pricingRegulationId = this.selectRowsValue.pricingModelParamsId
      console.log(this.lngform)
      let obj = this.getParams(this.form.region, this.tableData2[0], this.tableDataF, this.elebuyform, this.tableData3, this.waterform, this.lngform)
      console.log(this.waterform)
      this.$api.cost.modifyPricingModelParams(pricingRegulationId, JSON.stringify(obj)).then(res => {
        if (res.success) {
          this.showMsg("设置成功")
          this.getCostType()
        }
      })
    },
    showMsg (msg) {
      //展示提示信息
      this.$notify({
        title: "提示",
        message: `${msg}`,
        type: "warning"
      });
    },
    getDataAfter (res) {
      //电水气商业，阶梯，峰平谷保存之后，清楚选中行跟选中状态
      this.alarm = false;
      if (!res.success) {
        return;
      }
      this.rowselected = false;
      this.selectRowsValue = {};
      this.getCostType();
    },
    delerowtime (row, type) {//删除一行
      if (type == "dig") {//弹窗内
        if (this.tableDataFpgTime.length == 1) {
          return
        }
      } else {
        this.tableData.push({ time0: '', time1: '', time2: '' })
        if (this.tableData.length == 1) {
          return
        }
      }

      this.$confirm('确认删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (type == "dig") {//弹窗内
          this.tableDataFpgTime.splice(row, 1)
        } else {
          this.tableData.splice(row, 1)
          this.deleTimeRow()
        }
      })
    },
    deleTimeRow () {
      //时段
      let pricingRegulationId = this.selectRowsValue.id
      let timeSet = this.tableData.map(v => {
        return { type: v.time2, startTime: v.time0, endTime: v.time1 }
      })
      let havnull = timeSet.some(v => v.type == '' || v.startTime == '' || v.endTime == '')
      if (havnull) {
        this.showMsg("时段不能为空")
        return
      }
      this.$api.cost.setCompanyElectricityPricingMode1TimeRange(pricingRegulationId, timeSet).then(res => {
        if (!res.success) {
          return
        }
        this.showMsg("设置成功")
      })
    },
    //计量计价设置结束
    bindShowFtjjszVisible () {
      let vm = this;
      if (vm.rentalAreaFrom.id) {
        vm.getRentalAreaEnergyUsedMeasuring(vm.rentalAreaFrom.id);
        vm.ftjjszVisible = true;
      } else {
        vm.$message({
          message: "请选择您要查看分摊计价设置的场地！",
          type: "warning"
        });
      }
    },
    getRentalAreaEnergyUsedMeasuring (id) {
      let vm = this;
      vm.$api.rentalArea.getRentalAreaPublicEnergyUsedSharing1(id).then(res => {
        if (res) {
          vm.ftjjszTable = res.data;
          vm.ftjjszRow = {};
        }
      });
    },
    handleFtjjszRowClick (row) {
      let vm = this;
      vm.ftjjszRow = row;
    },
    //分摊计价双击事件
    handleFtjjszRowDoubleClick (val) {
      let vm = this;
      vm.rentalAreaPublicEnergyUsedSharingFrom.measureId = val.id;
      vm.rentalAreaPublicEnergyUsedSharingFrom.measureName = val.name;
      vm.measureChoiceVisible = false;
    },
    editFtjjszSave () {
      let vm = this;
      vm.$api.rentalArea
        .modifyRentalAreaPublicEnergyUsedSharing(
          vm.ftjjszRow.id,
          vm.ftjjszRow.energyType,
          vm.ftjjszRow.name,
          vm.ftjjszRow.startTime[0],
          vm.ftjjszRow.startTime[1],
          vm.ftjjszRow.measureId,
          vm.ftjjszRow.pointCode,
          vm.ftjjszRow.pointNumber,
          vm.ftjjszRow.expression,
          vm.ftjjszRow.unitPrice
        )
        .then(res => {
          if (res) {
            vm.$message("保存成功！");
            vm.$api.rentalArea
              .getRentalAreaPublicEnergyUsedSharing1(vm.rentalAreaFrom.id)
              .then(res => {
                if (res) {
                  vm.ftjjszTable = res.data;
                }
              });
          }
        });
    },
    bindShowAddftjj () {
      let vm = this;
      vm.editFtjjszVisible = true;
      vm.timeArr = [];
      vm.rentalAreaPublicEnergyUsedSharingFrom = {};
      vm.rentalAreaPublicEnergyUsedSharingFrom.rentalAreaId =
        vm.rentalAreaFrom.id;
      vm.editFtjjszTitle = "新增分摊计价";
    },
    bindShowAddftjjEdit () {
      let vm = this;
      if (JSON.stringify(vm.ftjjszRow) == "{}") {
        vm.$message({
          message: "请选择您要修改分摊计价设置！",
          type: "warning"
        });
        return;
      }
      vm.$api.measure.getMeasureInfo(vm.ftjjszRow.measureId).then(res => {
        vm.ftjjszRow.measureName = res.data.name;
        vm.ftjjszRow.energyType = vm.ftjjszRow.energyType.toString();
        vm.rentalAreaPublicEnergyUsedSharingFrom = JSON.parse(
          JSON.stringify(vm.ftjjszRow)
        );
        vm.rentalAreaPublicEnergyUsedSharingFrom.startTime = [
          vm.ftjjszRow.startTime,
          vm.ftjjszRow.endTime
        ];
      });
      vm.timeArr = [
        new Date(vm.ftjjszRow.startTime),
        new Date(vm.ftjjszRow.endTime)
      ];
      vm.editFtjjszVisible = true;
      vm.editFtjjszTitle = "修改分摊计价";
    },
    //计价分摊删除
    bindShowdeletftjjEdit () {
      let vm = this;
      if (JSON.stringify(vm.ftjjszRow) == "{}") {
        vm.$message({
          message: "请选择您要修改分摊计价设置！",
          type: "warning"
        });
        return;
      }
      vm.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          vm.$api.rentalArea
            .deleteRentalAreaPublicEnergyUsedSharing(vm.ftjjszRow.id)
            .then(res => {
              this.$message({
                type: "success",
                message: "删除成功"
              });
              vm.getRentalAreaEnergyUsedMeasuring(vm.rentalAreaFrom.id);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    //测量点选择按钮
    ftjjtree () {
      if (JSON.stringify(this.ftjjszRow) == "{}") {
        this.$message({
          message: "请选择测量点！",
          type: "warning"
        });
        return;
      }
      this.handleFtjjszRowDoubleClick(this.ftjjszRow);
    },
    //计价分摊新增保存
    bindSaveRentalAreaPublicEnergyUsedSharing () {
      let vm = this;
      if (!vm.rentalAreaPublicEnergyUsedSharingFrom.energyType) {
        vm.$message({
          message: "请选择分摊后的用量能源类型！",
          type: "warning"
        });
        return;
      }
      if (
        !vm.rentalAreaPublicEnergyUsedSharingFrom.name ||
        vm.rentalAreaPublicEnergyUsedSharingFrom.name.length <= 0
      ) {
        vm.$message({
          message: "请填写分摊名称！",
          type: "warning"
        });
        return;
      }
      if (
        !vm.rentalAreaPublicEnergyUsedSharingFrom.measureId ||
        vm.rentalAreaPublicEnergyUsedSharingFrom.measureId.length <= 0
      ) {
        vm.$message({
          message: "请选择测量点！",
          type: "warning"
        });
        return;
      }
      if (
        !vm.rentalAreaPublicEnergyUsedSharingFrom.pointCode ||
        vm.rentalAreaPublicEnergyUsedSharingFrom.pointCode.length <= 0
      ) {
        vm.$message({
          message: "请填写测量编码！",
          type: "warning"
        });
        return;
      }
      if (vm.rentalAreaPublicEnergyUsedSharingFrom.pointNumber.length <= 0) {
        vm.$message({
          message: "请填写测量编号！",
          type: "warning"
        });
        return;
      }
      if (
        !vm.rentalAreaPublicEnergyUsedSharingFrom.expression ||
        vm.rentalAreaPublicEnergyUsedSharingFrom.expression.length <= 0
      ) {
        vm.$message({
          message: "请填写用能分摊表达式！",
          type: "warning"
        });
        return;
      }
      var regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/;
      if (
        !vm.rentalAreaPublicEnergyUsedSharingFrom.unitPrice ||
        vm.rentalAreaPublicEnergyUsedSharingFrom.unitPrice.length <= 0 ||
        regNeg.test(vm.rentalAreaPublicEnergyUsedSharingFrom.unitPrice)
      ) {
        vm.$message({
          message: "请正确填写单价！",
          type: "warning"
        });
        return;
      }
      if (vm.rentalAreaPublicEnergyUsedSharingFrom.pointCode.length >= 9) {
        vm.$message({
          message: "测量编码不能超过9位！",
          type: "warning"
        });
        return;
      }
      if (vm.rentalAreaPublicEnergyUsedSharingFrom.pointNumber.length >= 9) {
        vm.$message({
          message: "测量编号不能超过9位！",
          type: "warning"
        });
        return;
      }
      if (vm.rentalAreaPublicEnergyUsedSharingFrom.unitPrice.length >= 8) {
        vm.$message({
          message: "单价不能超过8位！",
          type: "warning"
        });
        return;
      }
      //新增
      if (!vm.rentalAreaPublicEnergyUsedSharingFrom.id) {
        vm.$api.rentalArea
          .addRentalAreaPublicEnergyUsedSharing(
            vm.rentalAreaPublicEnergyUsedSharingFrom.rentalAreaId,
            vm.rentalAreaPublicEnergyUsedSharingFrom.energyType,
            vm.rentalAreaPublicEnergyUsedSharingFrom.name,
            vm.rentalAreaPublicEnergyUsedSharingFrom.startTime == undefined
              ? ""
              : vm.rentalAreaPublicEnergyUsedSharingFrom.startTime[0],
            vm.rentalAreaPublicEnergyUsedSharingFrom.startTime == undefined
              ? ""
              : vm.rentalAreaPublicEnergyUsedSharingFrom.startTime[1],
            vm.rentalAreaPublicEnergyUsedSharingFrom.measureId,
            vm.rentalAreaPublicEnergyUsedSharingFrom.pointCode,
            vm.rentalAreaPublicEnergyUsedSharingFrom.pointNumber,
            vm.rentalAreaPublicEnergyUsedSharingFrom.expression,
            vm.rentalAreaPublicEnergyUsedSharingFrom.unitPrice
          )
          .then(res => {
            if ((res.success = false)) {
              return;
            }
            vm.$message({
              message: "新增成功",
              type: "success"
            });
            vm.getRentalAreaEnergyUsedMeasuring(vm.rentalAreaFrom.id);
            vm.editFtjjszVisible = false;
          });
      } else {
        vm.$api.rentalArea
          .modifyRentalAreaPublicEnergyUsedSharing(
            vm.rentalAreaPublicEnergyUsedSharingFrom.id,
            vm.rentalAreaPublicEnergyUsedSharingFrom.energyType,
            vm.rentalAreaPublicEnergyUsedSharingFrom.name,
            vm.rentalAreaPublicEnergyUsedSharingFrom.startTime == undefined
              ? ""
              : vm.rentalAreaPublicEnergyUsedSharingFrom.startTime[0],
            vm.rentalAreaPublicEnergyUsedSharingFrom.startTime == undefined
              ? ""
              : vm.rentalAreaPublicEnergyUsedSharingFrom.startTime[1],
            vm.rentalAreaPublicEnergyUsedSharingFrom.measureId,
            vm.rentalAreaPublicEnergyUsedSharingFrom.pointCode,
            vm.rentalAreaPublicEnergyUsedSharingFrom.pointNumber,
            vm.rentalAreaPublicEnergyUsedSharingFrom.expression,
            vm.rentalAreaPublicEnergyUsedSharingFrom.unitPrice
          )
          .then(res => {
            vm.$message({
              message: "修改成功",
              type: "success"
            });
            vm.getRentalAreaEnergyUsedMeasuring(vm.rentalAreaFrom.id);
            vm.editFtjjszVisible = false;
          });
      }
    },
    bindShowMeasureChoice () {
      let vm = this;
      //获取组织架构节点
      vm.$api.orgStructNode.getORGStructNodes(this.$store.state.user.currentCompanyId).then(res => {
        if (res) {
          let data = res.data.sort((a, b) => {
            return a.orderNum - b.orderNum;
          });
          let frameworkData = tree.creatTreeJson(data, 0);
          vm.frameworkData = frameworkData;
          vm.measureChoiceVisible = true;
        }
      });
    },
    bindNodeClick (node) {
      let vm = this;
      //获取组织架构节点
      vm.$api.orgStructNode.getMountedMeasures(node.id).then(res => {
        if (res) {
          vm.measureTable = res.data;
        }
      });
    }
  }
};
</script>
<style>
.el-time-panel.el-popper {
  width: 128px;
}
</style>
<style scoped lang="scss">
.box {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #f5f5f5;
  padding: 10px;
  box-sizing: border-box;
}
.el-row {
  width: 100%;
  height: 100%;
  margin: 0 !important;
}
.top {
  padding-bottom: 20px;
  min-height: 300px;
}
.el-col {
  border-radius: 4px;
  height: 100%;
}
.parentflex {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  flex-direction: column;
  padding: 5px;
  box-sizing: border-box;
  background: #fff;
}
.tree_parentflex {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  flex-direction: column;
  padding: 5px;
  box-sizing: border-box;
  background: #fff;
}
.right-warp {
  padding: 10px;
  box-sizing: border-box;
  background: #fff;
  height: 100%;
}
.btn-box {
  text-align: right;
}
.table-box {
  padding-top: 10px;
  height: calc(100% - 50px);
}
.cgll-warp {
  padding: 14px;
  display: flex;
  width: 100%;
  height: 100%;
  text-align: left;
  box-sizing: border-box;
}
.left {
  flex: 1;
  width: 53%;
  overflow: auto;
  display: flex;
  flex-flow: column;
  margin-right: 14px;
}
.btn-content {
  //   flex:1;
  //   width: 100%;
  padding: 14px;
  box-sizing: border-box;
  border-radius: 4px;
}
.left-table {
  flex: 1;
  width: 100%;
  height: 100%;
  padding: 14px;
  margin-top: 14px;
  box-sizing: border-box;
  border-radius: 4px;
}
.right {
  // flex: 1;
  width: 27%;
  overflow: auto;
  display: flex;
  flex-flow: column;
}
.right-table {
  flex: 1;
  width: 100%;
  height: 100%;
  margin-top: 14px;
  padding: 14px;
  box-sizing: border-box;
  border-radius: 4px;
}
//计量设置开始
.box {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #f5f5f5;
  padding: 0 !important;
  box-sizing: border-box;
}
.el-row {
  width: 100%;
  height: 100%;
  margin: 0 !important;
}
.el-col {
  border-radius: 4px;
  height: 100%;
}
.parentflex {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  flex-direction: column;
  padding: 5px;
  box-sizing: border-box;
  background: #fff;
}
.tree_parentflex {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  flex-direction: column;
  padding: 5px;
  box-sizing: border-box;
  background: #fff;
}
.bgbox {
  background: #fff;
  position: relative;
  padding-top: 0;
  border: 1px solid #eee;
  box-sizing: border-box;
}
.time_box {
  width: 100%;
  height: 2rem;
  margin-top: 0.4rem;
  margin-left: 13px;
}

.contant_box {
  position: absolute;
  top: 2.25rem;
  bottom: 10px;
  left: 10px;
  right: 10px;
}
.box_btn {
  height: 40px;
  width: 100%;
  line-height: 40px;
  display: flex;
  align-items: flex-end;
  border-bottom: 2px solid #00368e;
}
.box_btn p {
  // font-size: 14px;
  color: #000;
  height: 30px;
  width: 96px;
  line-height: 30px;
  text-align: center;
  border: 1px solid #f5f5f5;
  border-bottom: none;
  cursor: pointer;
}
.box_btn .active {
  background: #00368e;
  color: #fff;
}
.box_con {
  position: absolute;
  top: 50px;
  bottom: 0px;
  width: 100%;
  display: flex;
}
.box_con_ {
  position: absolute;
  top: 45px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  overflow: hidden;
}
.chart_box {
  position: absolute;
  top: 10px;
  width: 100%;
  height: 600px;
  overflow: hidden;
}
.table_box {
  position: absolute;
  top: 615px;
  width: 100%;
  height: auto;
}
.charts {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
/* .btn{
  height:2.3rem
} */
.elechart_box {
  width: 100%;
  height: auto;
}
.eletable_box {
  width: 100%;
  height: auto;
}

// 内容展示部分
.contant_box {
  .center {
    margin-top: 1rem;
    height: 580px;
    overflow: hidden;
  }
}
.lfont ::v-deep .el-form-item__label {
  text-align: right;
  vertical-align: middle;
  float: left;
  color: #606266;
  line-height: 2.5rem;
  padding: 0 12px 0 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  // font-size: 14px !important;
}
.nc ::v-deep .el-input[data-v-2aaa65e5] {
  width: 197px !important;
}
.treewindow {
  width: 100%;
  height: 450px;
  overflow: hidden;
  padding: 5px;
  box-shadow: border-box;
}
.body_item {
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  justify-content: flex-start;
}
.left_tree {
  width: 250px;
  height: 100%;
  overflow: hidden;
  border: 1px solid #ccc;
  margin-right: 10px;
  box-sizing: border-box;
}
.left_tree > div {
  height: 100% !important;
}
.right_table {
  display: flex;
  flex: 1;
  height: 100%;
  border: 1px solid #ccc;
  box-sizing: border-box;
}
//计量设置结束
//计量计价设置开始
.pagebox_cbjj {
  .el-tabs.el-tabs--card.el-tabs--top {
    height: 100% !important;
    position: relative !important;
  }
  width: 100%;
  height: 100%;
  overflow: hidden;
  padding: 10px;
  box-sizing: border-box;

  .relative {
    position: relative;
  }
  .el-tabs__content {
    position: absolute !important;
    top: 45px;
    width: 100%;
    bottom: 5px;
  }
  .box-card .el-tabs__item.is-top:last-child {
    color: #ff4949;
  }
  .btnbox {
    width: 100%;
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;
  }
  .btnbox_ {
    width: 90%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 10px;
  }
  .eletable {
    margin-top: 10px;
    p {
      font-size: 14px;
    }
  }
  .itemgroup {
    width: 100%;
    position: absolute;
    top: 100px;
    bottom: 10px;
  }
  .addrow {
    color: #409eff;
    cursor: pointer;
    display: inline-block;
    margin: 5px 5px;
  }

  .el-table .cell {
    text-overflow: clip !important;
  }
}
.itemsLeft ::v-deep {
  width: 100%;
  height: 550px;
  display: flex;
  padding: 10px;
  box-sizing: border-box;
}
.itemgrounp ::v-deep {
  height: 100%;
  flex: 1;
}
//计量计价设置结束
/**分摊计价设置 */
.ftjjsz-warp {
  display: flex;
  background: #ffffff;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  flex-flow: column;
}
.top {
  flex: 1;
  height: 400px;
  padding: 10px 10px 0px 10px;
}
.bottom {
  width: 100%;
  padding: 0px 10px 10px 10px;
  box-sizing: border-box;
}
.label {
  padding: 10px 0px;
}
.btn-ftjjsz-content {
  padding-top: 10px;
  margin: 0px auto;

  text-align: center;
}

.choice-warp {
  display: flex;
  height: 500px;
  width: 300px;
  margin-left: 65px;
}
.choice-left {
  flex: 0 0 250px;
  margin-right: 35px;
  border: 1px solid;
  overflow: auto;
}
.choice-right {
  flex: 0 0 320px;
  display: flex;
}
.nc .el-input {
  width: 197px !important;
}
.nc .el-input-number {
  position: relative;
  display: inline-block;
  width: 197px;
  line-height: 38px;
}
.jlSet .el-dialog__body {
  padding-top: 10px;
  padding-bottom: 10px;
  background: #f3f3f3;
}
.jlForm {
  background: #fff;
  padding: 14px;
}
.jlTable {
  padding: 14px;
  border-radius: 4px;
}
.elefeng {
  flex: 1;
}
.addrow {
  color: #409eff;
  cursor: pointer;
  display: inline-block;
  margin: 5px 5px;
}
</style>